var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.54 6.95984L13.8867 9.74651C13.3267 12.1532 12.22 13.1265 10.14 12.9265C9.80668 12.8998 9.44668 12.8398 9.06001 12.7465L7.94001 12.4798C5.16001 11.8198 4.30001 10.4465 4.95335 7.65984L5.60668 4.86651C5.74001 4.29984 5.90001 3.80651 6.10001 3.39984C6.88001 1.78651 8.20668 1.35318 10.4333 1.87984L11.5467 2.13984C14.34 2.79318 15.1933 4.17318 14.54 6.95984Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.14 12.9266C9.72663 13.2066 9.20663 13.4399 8.57329 13.6466L7.51996 13.9932C4.87329 14.8466 3.47996 14.1332 2.61996 11.4866L1.76663 8.85324C0.913292 6.20657 1.61996 4.80657 4.26663 3.95324L5.31996 3.60657C5.59329 3.5199 5.85329 3.44657 6.09996 3.3999C5.89996 3.80657 5.73996 4.2999 5.60663 4.86657L4.95329 7.6599C4.29996 10.4466 5.15996 11.8199 7.93996 12.4799L9.05996 12.7466C9.44663 12.8399 9.80663 12.8999 10.14 12.9266Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52661 5.68652L11.7599 6.50652",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87329 8.2666L9.80662 8.75994",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.ad268bbef7d58ec760ac836e870d811f.svg";
export { ForwardRef as ReactComponent };